import { Box, GridItem, Text } from "@chakra-ui/react";
import axios from "axios";
import { useState } from "react";
import { FileIcon } from "../../assets/svgs/Icons";
import { toast } from "react-toastify";

export const DocumentViewer = (props) => {
  const { referenceId, document, doc_from } = props;
  const { loading, setLoading } = useState("");

  // api call
  const getPresignedUrl = async (documentId, doc_type) => {
    const token = localStorage.getItem("cu_user");
    const values = {
      documentId: documentId,
      doc_type: doc_type,
      referenceId: referenceId,
      doc_from: doc_from
    };
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOST}/api/document/getsignurl`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response?.status === 200) {
        const presignedUrl = response?.data?.data;

        window.location.href = presignedUrl;
      } else {
        console.error("Something went wrong while downloading the document");
      }
    } catch (error) {
      console.error("Error While fetching document");
      toast.error("Error fetching document, please try again later.")
    }
  };

  return (
    <>
      <Box>
        {document?.length < 1 || document === null || document === undefined ? (
          <Box
            bg="#FFFFFF"
            w={"175px"}
            h={"125px"}
            borderRadius={"15px"}
            textAlign="center"
            display="flex"
            alignItems="center"
            boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
            mb="1rem"
          >
            <Text padding={"1rem"}>No Document Found</Text>
          </Box>
        ) : (
          <>
            {document?.map((doc) => {
              return (
                <GridItem
                  key={doc?._id}
                  onClick={() => getPresignedUrl(doc?._id, doc?.doc_type)}
                  as="button"
                  cursor="pointer"
                  tabIndex="0"
                  colSpan={1}
                  px="1rem"
                >
                  <Box
                    display={"flex"}
                    className="overflow-style"
                    margin={"0.3rem"}
                  >
                    <Box
                      bg="#FFFFFF"
                      w={"175px"}
                      h={"125px"}
                      borderRadius={"15px"}
                      boxShadow={" rgba(100, 100, 111, 0.2) 0px 7px 29px 0px"}
                      mb={"1rem"}
                    >
                      <>
                        <Box
                          display={"flex"}
                          justifyContent={"center"}
                          alignItems={"center"}
                          padding={"1rem"}
                        >
                          <FileIcon />
                        </Box>
                        <Text
                          width={"130px"}
                          height={"100px"}
                          whiteSpace={"nowrap"}
                          overflow={"hidden"}
                          textOverflow={"ellipsis"}
                          padding={"0.2rem"}
                          textColor={"#000000"}
                          margin="auto"
                        >
                          {doc?.name}
                        </Text>
                      </>
                    </Box>
                  </Box>
                </GridItem>
              );
            })}
          </>
        )}
      </Box>
    </>
  );
};
